/**
 * **素材を使う召喚**（Issue #647）。疑似イベント `material_summon`（`editorPorts/materialSummon.js`。素材の `move` をまとめ、
 * 出るモンスターも載せた 1 行）。分岐は素材の種類。状況の名前は `material_summon_<kind>`。
 * 事実: `materials`（`{ uid, code, level, isTuner, type, from }`）/ `materialCount` / `totalLevel` / `result`（出るモンスター。
 * まだ入力されていなければ null）/ `source`（処理中の効果のカード＝儀式魔法・融合魔法など `{ code, uid, chain }`。ルールの召喚は null）/ `tuners` / `nonTuners`（チューナーかどうかが分かった素材だけ）
 */
export const VARIANTS = Object.freeze([
  { name: 'synchro', label: 'シンクロ召喚（素材と出るモンスター）' },
  { name: 'fusion', label: '融合召喚（素材と出るモンスター）' },
  { name: 'ritual', label: '儀式召喚（素材と出るモンスター）' },
  { name: 'xyz', label: 'エクシーズ召喚（素材と出るモンスター）' },
  { name: 'link', label: 'リンク召喚（素材と出るモンスター）' },
  { name: 'tribute', label: 'アドバンス召喚（リリースと出るモンスター）' },
]);

export default Object.freeze({
  event: 'material_summon',
  variants: VARIANTS,
  classify({ payload }) {
    const d = payload?.data ?? {};
    if (!VARIANTS.some((v) => v.name === d.kind)) return null;
    const materials = Array.isArray(d.materials) ? d.materials : [];
    if (!materials.length) return null;
    return {
      ...payload,
      variant: d.kind,
      materials,
      materialCount: materials.length,
      totalLevel: d.totalLevel ?? null,
      result: d.result ?? null,
      source: d.source ?? null,
      tuners: materials.filter((m) => m.isTuner === true),
      nonTuners: materials.filter((m) => m.isTuner === false),
    };
  },
});
